import { __require as requireRequireObjectCoercible } from './node_modules-core-js-internals-require-object-coercible.js';

var toObject;
var hasRequiredToObject;

function requireToObject () {
	if (hasRequiredToObject) return toObject;
	hasRequiredToObject = 1;
	var requireObjectCoercible = requireRequireObjectCoercible();

	var $Object = Object;

	// `ToObject` abstract operation
	// https://tc39.es/ecma262/#sec-toobject
	toObject = function (argument) {
	  return $Object(requireObjectCoercible(argument));
	};
	return toObject;
}

export { requireToObject as __require };
//# sourceMappingURL=node_modules-core-js-internals-to-object.js.map
